export default "__VITE_ASSET__x5V6QCwn__"